"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitEventType = void 0;
exports.InitEventType = "analytics_layer_loaded_17e31d3d_4cd5_4905_8522_879fb9293e1e";
